export const STRINGS = {
  belongs: `Belong's`,
  standard: `Standard`,
  standardApplication:
    'Belong handles requests like this\u00a0according\u00a0to\u00a0our',
  requiredApplication:
    'Belong typically requires performing requests like this\u00a0according\u00a0to\u00a0our',
  recommendedApplication:
    'Belong typically recommends performing requests like this\u00a0according\u00a0to\u00a0our',
};
